import { Box, type BoxProps } from "@sidelinesports/fan-design-system";
import { clsx } from "clsx";
import styles from "./ListItem.module.css";

export type ListItemProps = BoxProps & {
  clickable?: boolean;
  children: React.ReactNode;
};

export const ListItem = ({ children, clickable, ...props }: ListItemProps) => {
  const isClickable = props.onClick || clickable;

  return (
    <Box
      className={clsx(styles["list-item"], isClickable && styles.clickable)}
      p={16}
      bg="primary"
      borderWidth={2}
      borderRadius={8}
      w="100%"
      aria-disabled={props["aria-disabled"] ?? "false"}
      {...props}
    >
      {children}
    </Box>
  );
};
